<script setup lang="ts">
import Dinero from 'dinero.js';
import type { ProductInfo } from '../model';

const props = defineProps<{
  productInfo: ProductInfo
  isAnnual: boolean
  index?: number
}>();
</script>

<template>
  <el-card class="pricing-card__container" :class="{ 'pricing-card__container--popular': props.index === 1 }" shadow="never" style="border-radius: 10px">
    <div class="pricing-card__header">
      <h2 class="pricing-card__title">
        {{ props.productInfo.product.name }}
      </h2>
      <span v-if="props.index === 1" class="pricing-card__tag">Most popular</span>
    </div>
    <p class="pricing-card__description">
      {{ props.productInfo.product.description }}
    </p>
    <div class="pricing-card__price">
      <template v-if="isAnnual">
        <span class="pricing-card__price-amount">{{ Dinero({ amount: props.productInfo.annualPrice?.tiers[0].flat_amount, currency: 'USD' }).toFormat('$0,0.00') }}</span>
      </template>
      <template v-else>
        <span class="pricing-card__price-amount">{{ Dinero({ amount: props.productInfo.monthlyPrice?.tiers[0].flat_amount, currency: 'USD' }).toFormat('$0,0.00') }}</span>
      </template>
      <span v-if="!isAnnual" class="pricing-card__price-unit">per<br>month</span>
    </div>
    <span v-if="isAnnual" class="pricing-card__up-to">up to {{ props.productInfo.annualPrice?.tiers[0].up_to }} employees then {{ Dinero({ amount: props.productInfo.annualPrice?.tiers[1].unit_amount, currency: 'USD' }).toFormat('$0,0.00') }} for each</span>
    <span v-else class="pricing-card__up-to">up to {{ props.productInfo.monthlyPrice?.tiers[0].up_to }} employees then {{ Dinero({ amount: props.productInfo.monthlyPrice?.tiers[1].unit_amount, currency: 'USD' }).toFormat('$0,0.00') }} for each</span>
    <el-button
      type="primary"
      size="large"
      class="pricing-card__start"
    >
      Start trial
    </el-button>
    <div v-if="props.productInfo.product.features.length" class="pricing-card__features">
      <div class="pricing-card__features-title">
        This includes:
      </div>
      <div v-for="(feature, ind) in props.productInfo.product.features" :key="ind" class="pricing-card__feature">
        <el-icon><el-icon-check /></el-icon>
        <span>{{ feature.name }}</span>
      </div>
    </div>
  </el-card>
</template>

<style scoped lang="scss">
.pricing-card {
    &__container {
        width: 100%;
        min-height: 370px;
        border-radius: 10px;
        &--popular {
          background-color: #eeeeee;
        }
      }
      &__title {
        font-size: 21px;
      }
      &__header {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 10px;
      }
      &__tag {
        font-size: 13px;
        padding: 4px 8px;
        border-radius: 4px;
        background-color: #1a1a1a;
        color: #fff;
      }
      &__description {
        font-size: 13px;
        opacity: 0.5;
        min-height: 40px;
      }
      &__price {
        margin-bottom: 5px;
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 4px;
      }
      &__price-amount {
        font-size: 36px;
        font-weight: bold;

      }
      &__price-unit {
        font-size: 13px;
        color: #1a1a1a;
        opacity: 0.5;
      }
      &__up-to {
        display: block;
        margin-bottom: 20px;
        font-size: 13px;
        color: #1a1a1a;
        opacity: 0.5;
      }
      &__start {
        width: 100%;
        border-radius: 10px;
      }
      &__features {
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        gap: 10px;
      }
      &__features-title {
        font-size: 13px;
        opacity: 0.5;
      }
      &__feature {
        font-size: 13px;
        display: flex;
        align-items: center;
        gap: 10px;
      }
}
</style>
